import { all, takeLatest } from 'redux-saga/effects';

import { getTechniciansAction } from '@/redux/actions';

import { getTechniciansSaga } from './get-technicians';

export default function* root(): Generator {
  yield all([takeLatest(getTechniciansAction.request.type, getTechniciansSaga)]);
}
